import { Inject, Injectable } from '@angular/core';
import { RestService } from 'src/app/core/services/rest.service';
import { DailyTimeEntryModel, TimesheetModel } from './timesheet.models';
import { formatDate } from './timesheet.state';
import { User } from '@sentry/angular';

@Injectable({
    providedIn: 'root',
})
export class TimesheetsService {
    constructor(@Inject(RestService) private restService: RestService) {}

    public async getContributor(
        userId: string,
    ): Promise<{ user: User; dailyTimeEntries: DailyTimeEntryModel[] }> {
        const path = `/timesheets/contributor/${userId}`;
        return this.restService.get(path, {});
    }

    public async getTimesheetsBetween(
        from: Date,
        to: Date,
        userId?: string,
    ): Promise<TimesheetModel[]> {
        const fromStr = formatDate(from);
        const toStr = formatDate(to);
        const path = `/timesheets/${userId ? '/' + userId : ''}${fromStr}/${toStr}`;
        return await this.restService.get(path, {});
    }

    public async getLastTimesheets(): Promise<TimesheetModel[]> {
        const path = `/timesheets`;
        return await this.restService.get(path, {});
    }

    public async getUncompletedweeks(): Promise<Date[]> {
        const path = `/timesheets/uncompletedweeks`;
        return await this.restService.get(path, {});
    }

    public async updateTimesheets(entries: DailyTimeEntryModel[]): Promise<void> {
        const path = `/timesheets`;
        return await this.restService.patch(path, {}, entries);
    }
}
